<template>
  <div>
    <div class="loading-overlay" v-if="loading">
      <loading :active.sync="loading" :can-cancel="false" :is-full-page="true">
        <div class="d-flex flex-column justify-content-center align-items-center">
          <img class="rotate" src="@/assets/logo/logo.png" alt="Logo"/>
          <br>
          <span class="fw-bolder text-center text-dark-emphasis text-uppercase">Please Wait...</span>
          <div id="wave">
            <span class="dot"></span>
            <span class="dot"></span>
            <span class="dot"></span>
          </div>
        </div>
      </loading>
    </div>
    <!-- Add your main content here -->
    <div class="main-content">
      <!-- Main content goes here -->
    </div>
  </div>
</template>


<script>
export default {
  name: 'Loader',
  computed: {
    loading() {
      return this.$store.getters.getLoadingState;
    },
  }
}
</script>

<style lang="scss" scoped>
.loading-overlay {
  position: fixed; /* Make it cover the entire viewport */
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(255, 255, 255, 0.8); /* Semi-transparent background */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000; /* Ensure it's on top of other      content */
}

.rotate {
  width: 30%; /* Adjust the size of the image */
  height: 30%; /* Keep the aspect ratio */
  border-radius: 50%;
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 1);
  transform: scale(1);
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.7);
  }
  70% {
    transform: scale(1);
    box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
  }
  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
  }
}

div#wave {
  position: relative;
  text-align: center;
  width: 100px;
  height: 100px;
  margin-left: auto;
  margin-right: auto;

  .dot {
    display: inline-block;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    margin-right: 3px;
    background: #303131;
    animation: wave 1.3s linear infinite;

    &:nth-child(2) {
      animation-delay: -1.1s;
    }

    &:nth-child(3) {
      animation-delay: -0.9s;
    }
  }
}

@keyframes wave {
  0%, 60%, 100% {
    transform: initial;
  }
  30% {
    transform: translateY(-15px);
  }
}

.main-content {
  /* Styles for your main content go here */
}
</style>

